import { environment } from '@env/environment';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PopupPrearrivalComponent } from '../popup-prearrival/popup-prearrival.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalChargesComponent } from '../checkin/modal-charges/modal-charges.component';
import { ModalLateChargesComponent } from '../checkin/modal-late-charges/modal-late-charges.component';
import { PaymentSuccessfulPopupComponent } from '../checkin/payment-successful-popup/payment-successful-popup.component';
import { EarlyCheckinPopupComponent } from '../checkin/early-checkin-popup/early-checkin-popup.component';
import { Storage } from "@ionic/storage";
import { CloudbedsService } from '@app/services/cloudbeds.service';
import { LoadingService } from '@app/shared/services/loading.service';
import { UsersApiService } from '@app/core/users-api/users-api.service';

@Component({
  selector: 'app-prearrival-checkin',
  templateUrl: './prearrival-checkin.component.html',
  styleUrls: ['./prearrival-checkin.component.scss'],
})
export class PrearrivalCheckinComponent implements OnInit {
  public environment = environment;
  options: any;
  showModal = true;
  showEarly = false;
  shoyPayment = false;
  showCards = false;
  newCard = false;
  cardAdded = false;
  showCardsForm = false;
  okPayment = false;
  upload = false;
  upload2 = false;
  upload3 = false;
  upload4 = false;
  newCard2 = false;
  earlyShow = false;
  editCard = false;
  cardAdded2 = false;
  lateCheckout = false;
  alreadyArrivalModal = false;
  afterArrival = false;
  afterArrival2 = false;
  showModal2: boolean = false;
  showEarly2: boolean = false;
  terms = false;
  reservation: any;
  isCheckin: any;
  isLogin = false;
  errorMessage = "";
  prearrivalommited: any;
  constructor(
    public storage: Storage,
    private modalCtrlr: ModalController,
    private loadingService: LoadingService,
    public cloudbedsService: CloudbedsService,
    private router: Router,
    public usersApi: UsersApiService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.usersApi.getUser().then(user => {
      this.isLogin = true;
      
    }).catch(err => {
    });
    this.route.queryParams.subscribe(params => {
      console.log(params)
      this.isCheckin = JSON.parse(params.isCheckin);
      if (params.prearrivalommited){
        this.prearrivalommited = JSON.parse(params.prearrivalommited);
      }
    })
    // setTimeout(() => {
    //   this.showEarly = true;
    // }, 3000);
    this.options = [
      {
        backgroundImage: '../../../assets/prearrival/id_background.png',
        iconImage: '../../../assets/prearrival/id.png',
        title: 'Pre Arrival ID Scan',
        details: 'Simplify Your Stay with Quick and Secure ID Verification',
        function: 'PreArrival'
      },
      {
        backgroundImage: '../../../assets/prearrival/upgrade_background.png',
        iconImage: '../../../assets/prearrival/upgrade.png',
        title: 'Upgrade Your Room',
        details: 'Enjoy More Time to Relax with Advanced Early Check-In',
        function: 'Upgrade'
      },
      {
        backgroundImage: '../../../assets/prearrival/early_background.png',
        iconImage: '../../../assets/prearrival/checkin.png',
        title: 'Early Check-In',
        details: 'Enjoy More Time to Relax with Advanced Early Check-In',
        function: 'EarlyCheckIn'
      },
      {
        backgroundImage: '../../../assets/prearrival/card_background.png',
        iconImage: '../../../assets/prearrival/card.png',
        title: 'Edit Card on File',
        details: 'Manage Your Payment Details and Keep Updated',
        function: 'EditCard'
      },
      {
        backgroundImage: '../../../assets/prearrival/checkout_background.png',
        iconImage: '../../../assets/prearrival/checkout.png',
        title: 'Late Check-Out',
        details: 'You Need to Stay more time? Extend Your Stay',
        function: 'LateCheckOut'
      }
    ]
  }
  // /checkin/payment/cards
  onItemClick(item){
    switch (item.function) {
      case 'PreArrival':
        this.showPreArrival();
        break;
      case 'EarlyCheckIn':
        this.earlyPopup();
        break;
      case 'Upgrade':
        this.router.navigate(['/welcome-checkin/upgrade-room'], {queryParams: {redirect: '/checkin/prearrival'}})
        break;
      case 'EditCard':
        this.router.navigate(['/tabs/checkin/payment/cards'])
        break;
      case 'LateCheckOut':
        this.chargesPopup();
        break;
      default:
        break;
    }
  }

  async continue() {
    await this.loadingService.presentLoading();
    this.storage.set("reservationValue", this.reservation)
    if (environment.nexi.useCloudbedsAPI){
      var propertyId = await this.storage.get('propertyId');
      if (!propertyId) {
        propertyId = environment.nexi.propertyId;
      }
      this.cloudbedsService.findReservation({reservationId: this.reservation.toString(), propertyId: propertyId}).then(async (resp: any) => {
        console.log(resp);
        this.errorMessage = "";
        if (resp && resp.length > 0) {
          let reservationData = resp[0].data;
          this.storage.set("reservationData", reservationData)
          this.loadingService.dismiss();
          if (this.isLogin) {
            this.router.navigate(["/tabs/checkin/page"]);
          }
          else if (reservationData.status == 'confirmed' || reservationData.status == 'checked_in'){
            if (!environment.nexi.loginOptional)
              this.router.navigate(['/sign-up'], {queryParams: {prearrival: false, prearrivalommited: true}})
            else
              this.router.navigate(["/tabs/checkin/page"]);


            // const modal = await this.modalCtrlr.create({
            //   cssClass: 'popuparrival-modal-small',
            //   component:  PopupPrearrivalComponent,
            //   componentProps: {
            //     title: `Welcome! <br> ${reservationData.guestName}`,
            //     text: `Discover all the great features we’ve prepared for your stay. If you’d like to fill your pre arrival, please fill out your profile to get started.`,
            //     showList: false,
            //     buttons: [
            //       {
            //         title: 'Sign In',
            //         value: 'signin'
            //       },
            //       {
            //         title: 'Home',
            //         value: 'home'
            //       }
            //     ]
            //   }
            // });
            // await modal.present();
            // const { data } = await modal.onDidDismiss();
            // if (data && data.value == 'signin') {
            //   this.router.navigate(['/sign-up'], {queryParams: {prearrival: true, prearrivalommited: this.prearrivalommited}})
            // }else{
            //   this.gohome();
            // }
          }
        }
        else {
          // not found
          this.loadingService.dismiss();
          this.errorMessage = "Reservation Not Found";
        }
      }).catch((error) => {
        this.loadingService.dismiss();
          this.errorMessage = error.message;
      })
    }
    //else{
    //     this.loadingService.dismiss();
    //   const modal = await this.modalCtrlr.create({
    //         cssClass: 'popuparrival-modal-small',
    //         component:  PopupPrearrivalComponent,
    //         componentProps: {
    //           title: `Welcome! <br> Douglas Ralston`,
    //           text: `Discover all the great features we’ve prepared for your stay. If you’d like to fill your pre arrival, please fill out your profile to get started.`,
    //           showList: false,
    //           buttons: [
    //             {
    //               title: 'Sign In',
    //               value: 'signin'
    //             },
    //             {
    //               title: 'Home',
    //               value: 'home'
    //             }
    //           ]
    //         }
    //       });
    //       await modal.present();
    //       const { data } = await modal.onDidDismiss();
    //       if (data && data.value == 'signin') {
    //         this.router.navigate(['/sign-up'], {queryParams: {prearrival: true, prearrivalommited: this.prearrivalommited}})
    //       }else{
    //         this.gohome();
    //       }
    // }
  }

  continuecheckin(){
    if (!environment.nexi.loginOptional) {
      this.router.navigate(['/checkin/prearrival-data'], {queryParams: {isCheckin: true, prearrivalommited: this.prearrivalommited}});
    }
    else {
      this.router.navigate(['/checkin/prearrival-data'], {queryParams: {isCheckin: true, prearrivalommited: this.prearrivalommited}});
    }
  }

  gohome(){
    this.router.navigate(['/tabs/home'])
  }

  goBack(){
    window.history.back();
  }

  async chargesPopup() {
    const modal = await this.modalCtrlr.create({
      cssClass: 'charges-late-modal',
      component:  ModalLateChargesComponent,
      componentProps: {
        title: 'Late Check-Out',
        info: 'New Check-Out - 3:00 PM',
        text: 'We Appreciate You Staying Longer!',
        buttons: [
          {
            title: 'Dismiss',
            value: 'cancel'
          }
        ]
      }
    });
    await modal.present().then( result => { } );
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    console.log(data)
    if(data.data){
      this.paymentOk();
    }
  }

  async earlyPopupShow() {
    const modal = await this.modalCtrlr.create({
      cssClass: 'charges-late-modal',
      component:  ModalLateChargesComponent,
      componentProps: {
        title: 'Early Check-In',
        info: 'New Check-In - 6:00 AM',
        text: 'We can’t wait to have you here',
        buttons: [
          {
            title: 'Dismiss',
            value: 'cancel'
          }
        ]
      }
    });
    await modal.present().then( result => { } );
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    console.log(data)
    if(data.data){
      this.paymentOk();
    }
  }

  async earlyPopup() {
    const modal = await this.modalCtrlr.create({
      cssClass: 'early-checkin-modal',
      component:  EarlyCheckinPopupComponent,
      componentProps: {
        title: 'Early Check-In',
        image: 'assets/cico/login_logo.png',
        text: 'Early check-in isn’t possible right now, but we’ll do our best to prepare your room as soon as we can.',
        buttons: [
          {
            title: 'BACK',
            value: 'cancel'
          }
        ]
      }
    });
    await modal.present().then( result => { } );
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    // console.log(data)
    // if(data.data){
    //   this.earlyPopupShow();
    // }
  }

  async showPreArrival() {
    const modal = await this.modalCtrlr.create({
      cssClass: 'popuparrival-modal',
      component:  PopupPrearrivalComponent,
      componentProps: {
        title: 'PRE ARRIVAL SCAN ID',
        image: 'assets/cico/home_logo.png',
        text: 'We’ve got your ID on file. Do you need to upload a different one?',
        buttons: [
          {
            title: 'BACK',
            value: 'cancel'
          },
          {
            title: 'CONTINUE',
            value: 'cancel'
          }
        ]
      }
    });
    await modal.present().then( result => { } );
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    // if(data.value){
    //   this.paymentOk();
    // }
    // this.router.navigate(["tabs/checkin/payment"]);
    // if (data && data.result) {
    //   this.modalCtrlr.dismiss({ result: null });
    //   return '';
    // }
  }

  async paymentOk() {
    const modal = await this.modalCtrlr.create({
      cssClass: 'popuparrival-modal',
      component:  PaymentSuccessfulPopupComponent,
      componentProps: {
        title: 'Payment Successful',
        image: 'assets/cico/check.png',
        text: 'Payment fee details emailed to',
        email: 'dr@trueomni.com',
        description: "Click link for assistance; we'll notify of mishaps. Thank You!",
        small: 'Contact us for any question',
        buttons: [
          {
            title: 'DONE',
            value: 'cancel'
          }
        ]
      }
    });
    await modal.present().then( result => { } );
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    // this.router.navigate(["tabs/checkin/payment"]);
    // if (data && data.result) {
    //   this.modalCtrlr.dismiss({ result: null });
    //   return '';
    // }
  }
}
